// node_modules
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useForm, Controller, set } from "react-hook-form";

// primereact components
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from "primereact/accordion";
import { OrderList } from "primereact/orderlist";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { SelectButton } from "primereact/selectbutton";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import { FileUpload } from "primereact/fileupload";
import { Dropdown } from "primereact/dropdown";
import { ToastContext } from "../../../App";

// redux
import { useGetStationListQuery } from "../../../redux/services/foodStation";
import {
  useGetStationOptionsListQuery,
  useSaveOptionsOrderMutation,
  useSaveGroupOrderMutation,
  useCreateOptionGroupMutation,
  useUpdateOptionGroupMutation,
  useDeleteOptionGroupMutation,
  useCreateOptionMutation,
  useUpdateOptionMutation,
  useDeleteOptionMutation,
  useUploadImageMutation,
} from "../../../redux/services/foodStationOptions";
import { setLoading } from "../../../redux/slices/app.slice";

// utils
import getSubdomain from "../../../utils/getSubdomain";

// styles
import * as styles from "./StationMenuItem.module.css";

const StationMenuItem = () => {
  const { id: stationId } = useParams();

  const dispatch = useDispatch();
  const showToast = useContext(ToastContext);

  const {
    data: stations,
    isSuccess: isGetStationsSuccess,
    isError: isGetStationsError,
  } = useGetStationListQuery(getSubdomain());
  const {
    data: stationOptions,
    isSuccess: isGetStationOptionsSuccess,
    isError: isGetStationOptionsError,
  } = useGetStationOptionsListQuery({
    id: stationId,
    subDomain: getSubdomain(),
  });
  const [
    saveOptionsOrder,
    {
      isSuccess: isSaveOptionsOrderSuccess,
      isError: isSaveOptionsOrdersError,
      error: saveOptionsOrdersError,
    },
  ] = useSaveOptionsOrderMutation();
  const [
    saveGroupOrder,
    {
      isSuccess: isSaveGroupOrderSuccess,
      isError: isSaveGroupOrderError,
      error: saveGroupOrderError,
    },
  ] = useSaveGroupOrderMutation();
  const [
    createOptionGroup,
    {
      isSuccess: isCreateOptionGroupSuccess,
      isError: isCreateOptionGroupError,
      error: createOptionGroupError,
    },
  ] = useCreateOptionGroupMutation();
  const [
    updateOptionGroup,
    {
      isSuccess: isUpdateOptionGroupSuccess,
      isError: isUpdateOptionGroupError,
      error: updateOptionGroupError,
    },
  ] = useUpdateOptionGroupMutation();
  const [
    deleteOptionGroup,
    {
      isSuccess: isDeleteOptionGroupSuccess,
      isError: isDeleteOptionGroupError,
      error: deleteOptionGroupError,
    },
  ] = useDeleteOptionGroupMutation();
  const [
    createOption,
    {
      isSuccess: isCreateOptionSuccess,
      isError: isCreateOptionError,
      error: createOptionError,
    },
  ] = useCreateOptionMutation();
  const [
    updateOption,
    {
      isSuccess: isUpdateOptionSuccess,
      isError: isUpdateOptionError,
      error: updateOptionError,
    },
  ] = useUpdateOptionMutation();
  const [
    deleteOption,
    {
      isSuccess: isDeleteOptionSuccess,
      isError: isDeleteOptionError,
      error: deleteOptionError,
    },
  ] = useDeleteOptionMutation();
  const [
    uploadImage,
    {
      isSuccess: isUploadImageSuccess,
      isError: isUploadImageError,
      error: uploadImageError,
    },
  ] = useUploadImageMutation();

  const [currentStation, setCurrentStation] = useState();
  const [mode, setMode] = useState("create");
  const [showModal, setShowModal] = useState(false);
  const [showItemModal, setShowItemModal] = useState(false);
  const [currentGroup, setCurrentGroup] = useState({ name: "" });
  const [id, setId] = useState(null);
  const [itemId, setItemId] = useState(null);
  const [openedAcc, setOpenedAcc] = useState(0);
  const [showImageModal, setShowImageModal] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [menuItem, setMenuItem] = useState(null);

  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      title: "",
    },
  });

  const {
    control: control2,
    handleSubmit: handleSubmit2,
    setValue: setValue2,
  } = useForm();

  const multiple = watch("multiple");

  useEffect(() => {
    if (isGetStationsSuccess) {
      const station = stations.find((item) => item.id === +stationId);
      setCurrentStation(station);
      dispatch(setLoading(false));
    }
  }, [isGetStationsSuccess]);

  useEffect(() => {
    if (isCreateOptionGroupSuccess) {
      showToast("success", "Group", "Group created!");
      setShowModal(false);
    }
  }, [isCreateOptionGroupSuccess]);
  
  useEffect(() => {
    if (isUpdateOptionGroupSuccess) {
      showToast("success", "Group", "Group updated!");
      setShowModal(false);
    }
  }, [isUpdateOptionGroupSuccess]);

  useEffect(() => {
    if (isCreateOptionGroupSuccess)
      showToast("success", "Group", "Group created!");
  }, [isCreateOptionGroupSuccess]);

  useEffect(() => {
    if (isUpdateOptionGroupSuccess)
      showToast("success", "Group", "Group updated!");
  }, [isUpdateOptionGroupSuccess]);

  useEffect(() => {
    if (isCreateOptionSuccess || isUpdateOptionSuccess) {
      setShowItemModal(false);
    }
  }, [isCreateOptionSuccess, isUpdateOptionSuccess]);

  useEffect(() => {
    if (isCreateOptionSuccess)
      showToast("success", "Option", "Option created!");
  }, [isCreateOptionSuccess]);

  useEffect(() => {
    if (isUpdateOptionSuccess)
      showToast("success", "Option", "Option updated!");
  }, [isUpdateOptionSuccess]);

  useEffect(() => {
    if (isGetStationsError) {
      showToast("error", "Station", "Unable to load stations");
      dispatch(setLoading(false));
    }
  }, [isGetStationsError]);

  useEffect(() => {
    if (isGetStationOptionsError) {
      showToast("error", "Option", "Unable to load station options");
      dispatch(setLoading(false));
    }
  }, [isGetStationOptionsError]);

  useEffect(() => {
    if (isSaveOptionsOrderSuccess)
      showToast("success", "Options", "Order updated!");
  }, [isSaveOptionsOrderSuccess]);

  useEffect(() => {
    if (isSaveOptionsOrdersError)
      showToast(
        "error",
        saveOptionsOrdersError?.status,
        saveOptionsOrdersError?.data?.message ||
          (saveOptionsOrdersError?.data?.errors && "Incorrect data")
      );
  }, [isSaveOptionsOrdersError]);

  useEffect(() => {
    if (isSaveGroupOrderSuccess)
      showToast("success", "Groups", "Order updated!");
  }, [isSaveGroupOrderSuccess]);

  useEffect(() => {
    if (isSaveGroupOrderError)
      showToast(
        "error",
        saveGroupOrderError?.status,
        saveGroupOrderError?.data?.message ||
          (saveGroupOrderError?.data?.errors && "Incorrect data")
      );
  }, [isSaveGroupOrderError]);

  useEffect(() => {
    if (isCreateOptionGroupError)
      showToast(
        "error",
        createOptionGroupError?.status,
        createOptionGroupError?.data?.message ||
          (createOptionGroupError?.data?.errors && "Incorrect data")
      );
  }, [isCreateOptionGroupError]);

  useEffect(() => {
    if (isUpdateOptionGroupError)
      showToast(
        "error",
        updateOptionGroupError?.status,
        updateOptionGroupError?.data?.message ||
          (updateOptionGroupError?.data?.errors && "Incorrect data")
      );
  }, [isUpdateOptionGroupError]);

  useEffect(() => {
    if (isDeleteOptionGroupSuccess)
      showToast("success", "Group", "Group deleted!");
  }, [isDeleteOptionGroupSuccess]);

  useEffect(() => {
    if (isDeleteOptionGroupError)
      showToast(
        "error",
        deleteOptionGroupError?.status,
        deleteOptionGroupError?.data?.message
      );
  }, [isDeleteOptionGroupError]);

  useEffect(() => {
    if (isCreateOptionError)
      showToast(
        "error",
        createOptionError?.status,
        createOptionError?.data?.message ||
          (createOptionError?.data?.errors && "Incorrect data")
      );
  }, [isCreateOptionError]);

  useEffect(() => {
    if (isUpdateOptionError)
      showToast(
        "error",
        updateOptionError?.status,
        updateOptionError?.data?.message ||
          (updateOptionError?.data?.errors && "Incorrect data")
      );
  }, [isUpdateOptionError]);

  useEffect(() => {
    if (isDeleteOptionSuccess)
      showToast("success", "Option", "Option deleted!");
  }, [isDeleteOptionSuccess]);

  useEffect(() => {
    if (isDeleteOptionError)
      showToast(
        "error",
        deleteOptionError?.status,
        deleteOptionError?.data?.message
      );
  }, [isDeleteOptionError]);

  useEffect(() => {
    if (isUploadImageError)
      showToast(
        "error",
        uploadImageError?.status,
        uploadImageError?.data?.message ||
          (uploadImageError?.data?.errors && "Incorrect data")
      );
  }, [isUploadImageError]);

  useEffect(() => {
    if (isUploadImageSuccess) {
      setShowImageModal(false);
      showToast("success", "Option", "Image uploaded!");
    }
  }, [isUploadImageSuccess]);

  const openModal = (mode, rowData) => (e) => {
    if (mode === "create") {
      setId(null);
      setValue("title", "");
      setValue("multiple", "Single Choice");
      setValue("max_multiple", { value: 2 });
    } else {
      setId(rowData.group_id);
      setValue("title", rowData.group_name);
      setValue(
        "multiple",
        rowData.allow_multiple ? "Multiple Choice" : "Single Choice"
      );
      setValue("max_multiple", { value: rowData.max_multiple });
    }
    setShowModal(true);
    setMode(mode);
  };

  const openItemModal = (mode, rowData, groupData) => (e) => {
    if (mode === "create") {
      setItemId(null);
      setValue2("item_title", "");
      setValue2("item_active", "");
      setValue2("item_cost", "");
      setValue2("item_note", "");
      setCurrentGroup(rowData);
    } else {
      setItemId(rowData.id);
      setId(groupData.group.group_id);
      setValue2("item_title", rowData.name);
      setValue2("item_active", rowData.visible ? "Active" : "Inactive");
      setValue2("item_cost", rowData.cost);
      setValue2("item_note", rowData.note);
      setCurrentGroup(groupData.group);
    }
    setShowItemModal(true);
    setMode(mode);
  };

  const onCreate = (data) => {
    createOptionGroup({
      subdomain: getSubdomain(),
      name: data.title,
      station_id: +stationId,
      allow_multiple: data.multiple !== "Single Choice",
      max_multiple:
        data.multiple === "Multiple Choice" ? +data.max_multiple.value : null,
    });
  };

  const onSaveEdit = (data) => {
    updateOptionGroup({
      id,
      data: {
        name: data.title,
        allow_multiple: data.multiple === "Multiple Choice",
        max_multiple:
          data.multiple === "Multiple Choice" ? +data.max_multiple.value : null,
      },
      subDomain: getSubdomain(),
    });
  };

  const onItemCreate = (data) => {
    console.log(data);
    const cost =
      typeof data.item_cost === "string"
        ? +data.item_cost.slice(1)
        : data.item_cost;
    const payload = {
      name: data.item_title,
      visible: data.item_active === "Active",
      cost,
      note: data.item_note,
      group_id: currentGroup.group_id,
    };
    createOption({ data: payload, subDomain: getSubdomain() });
  };

  const onItemSaveEdit = (data) => {
    console.log(data);
    updateOption({
      id: itemId,
      data: {
        group_id: id,
        name: data.item_title,
        visible: data.item_active === "Active",
        cost: +data.item_cost,
        note: data.item_note,
      },
      subDomain: getSubdomain(),
    });
  };

  const moveGroupUp = (group, groups) => () => {
    const payload = {
      groups: [],
      station_id: +stationId,
    };

    let move = false;

    groups.toReversed().forEach((item, index, array) => {
      if (move) {
        payload.groups.unshift({
          id: array[index].group.group_id,
          order: array.length - index,
        });

        payload.groups.unshift({
          id: array[index - 1].group.group_id,
          order: array.length - index - 1,
        });

        move = false;
      } else {
        if (item.group.group_id !== group.group.group_id) {
          payload.groups.unshift({
            id: item.group.group_id,
            order: array.length - index - 1,
          });
        } else {
          move = true;
        }
      }
    });
    setOpenedAcc(null);
    saveGroupOrder({
      payload,
      subDomain: getSubdomain(),
    });
  };

  const moveGroupDown = (group, groups) => () => {
    const payload = {
      groups: [],
      station_id: +stationId,
    };
    setOpenedAcc(null);
    let move = false;
    groups.forEach((item, index, array) => {
      if (move) {
        payload.groups.push({
          id: array[index].group.group_id,
          order: payload.groups.length,
        });
        payload.groups.push({
          id: array[index - 1].group.group_id,
          order: payload.groups.length,
        });
        move = false;
      } else {
        if (item.group.group_id !== group.group.group_id) {
          payload.groups.push({
            id: item.group.group_id,
            order: payload.groups.length,
          });
        } else {
          move = true;
        }
      }
    });
    saveGroupOrder({ payload, subDomain: getSubdomain() });
  };

  const openImageModal = (rowData) => () => {
    setCurrentImage(
      `https://dwtl.food/public/images/${rowData.item.image_name}`
    );
    setMenuItem(rowData);
    // setImageStationName(rowData.name);
    // setId(rowData.id);
    setShowImageModal(true);
  };

  const onImageSelect = (e) => {
    setCurrentImage(e.files[0].objectURL);
  };

  const onImageUpload = (e) => {
    uploadImage({
      id: stationId,
      subdomain: getSubdomain(),
      data: e.files[0],
      optionId: menuItem.item.id,
      groupId: menuItem.group.group.group_id,
    });
  };

  const itemTemplate = (rowData) => (item) => {
    console.log(rowData, item);
    return (
      <div className={styles.stationMenuItem}>
        <div>
          <div
            style={{
              backgroundImage: `url(https://dwtl.food/public/images/${item.image_name})`,
              backgroundSize: "cover",
              height: "50px",
              width: "71px",
              backgroundColor: "gray",
              color: "#ffffff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={openImageModal({ group: rowData, item })}
          >
            <i className="pi pi-pencil"></i>
          </div>
        </div>
        <div>{item.name}</div>
        <div>${item.cost.toFixed(2)}</div>
        <div>
          {item.visible ? (
            <Button
              icon="pi pi-eye"
              className="p-button-text"
              onMouseUp={() => {
                updateOption({
                  id: item.id,
                  data: {
                    group_id: rowData.group.group_id,
                    visible: item.visible === "Active",
                  },
                  subDomain: getSubdomain(),
                });
              }}
            />
          ) : (
            <Button
              icon="pi pi-eye-slash"
              className="p-button-text"
              onMouseUp={() => {
                updateOption({
                  id: item.id,
                  data: {
                    group_id: rowData.group.group_id,
                    visible: item.visible !== "Active",
                  },
                  subDomain: getSubdomain(),
                });
              }}
            />
          )}
        </div>
        <div>{item.note}</div>
        <div>
          <div className="flex gap-2">
            <Button
              icon="pi pi-pencil"
              className="p-button-text"
              onMouseDown={openItemModal("edit", item, rowData)}
            />
            <Button
              icon="pi pi-trash"
              className="p-button-text"
              onMouseDown={() =>
                deleteOption({ id: item.id, subdomain: getSubdomain() })
              }
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.pageWrapper}>
      <div className="flex justify-content-between align-items-center mb-3">
        {currentStation && <h2>{currentStation.name} Management</h2>}
        <Button
          label="Create Option Group"
          icon="pi pi-plus"
          onClick={openModal("create")}
        />
      </div>

      <Button
        label="EXPAND ALL"
        className={`p-button-text ${styles.expandButton}`}
        onClick={() => {
          setOpenedAcc(
            stationOptions?.length
              ? stationOptions.map((_, index) => index)
              : null
          );
        }}
      />

      <Button
        label="COLLAPSE ALL"
        className={`p-button-text ${styles.collapseButton}`}
        onClick={() => {
          setOpenedAcc(null);
        }}
      />

      {isGetStationOptionsSuccess && (
        <Accordion
          activeIndex={openedAcc}
          multiple
          onTabClose={({ originalEvent, index }) => {
            const attr = originalEvent.target.getAttribute("data-pc-section");
            if (attr !== "root" && attr !== "icon") {
              setOpenedAcc(index);
            }
          }}
          onTabOpen={({ originalEvent, index }) => {
            const attr = originalEvent.target.getAttribute("data-pc-section");
            if (attr !== "root" && attr !== "icon") {
              setOpenedAcc(index);
            }
          }}
          onTabChange={({ originalEvent, index }) => {
            const attr = originalEvent.target.getAttribute("data-pc-section");
            if (attr !== "root" && attr !== "icon") {
              setOpenedAcc(index);
            }
          }}
        >
          {stationOptions.map((item, index, array) => {
            return (
              <AccordionTab
                header={
                  <div className={styles.accordionHeader}>
                    <div>
                      <span>{item.group.group_name}</span>
                      {"  "}
                      <span>
                        {item.group.allow_multiple === 1
                          ? `( Multiple Choice MAX ${item.group.max_multiple} )`
                          : "( Single Choice)"}
                      </span>
                    </div>

                    <div>
                      <Button
                        icon="pi pi-arrow-up"
                        className="p-button-text"
                        disabled={index === 0}
                        onMouseDown={moveGroupUp(item, array)}
                      />
                      <Button
                        icon="pi pi-arrow-down"
                        className="p-button-text"
                        disabled={array.length - 1 === index}
                        onMouseDown={moveGroupDown(item, array)}
                      />
                      <Button
                        icon="pi pi-plus"
                        className="p-button-text"
                        onMouseDown={openItemModal("create", item.group)}
                      />
                      <Button
                        icon="pi pi-pencil"
                        className="p-button-text"
                        onMouseDown={openModal("edit", item.group)}
                      />
                      <Button
                        icon="pi pi-trash"
                        className="p-button-text"
                        onMouseDown={() =>
                          deleteOptionGroup({
                            id: item.group.group_id,
                            subDomain: getSubdomain(),
                          })
                        }
                      />
                    </div>
                  </div>
                }
              >
                <div className={styles.listWrapper}>
                  <OrderList
                    dataKey="id"
                    value={item.items}
                    onChange={(e) => {
                      saveOptionsOrder({
                        payload: {
                          options: e.value.map((item, index) => {
                            return { id: item.id, order: index + 1 };
                          }),
                          group_id: item.group.group_id,
                        },
                        subDomain: getSubdomain(),
                      });
                    }}
                    header={
                      <div className={styles.header}>
                        <div>Image</div>
                        <div>Title</div>
                        <div>Cost</div>
                        <div>Active</div>
                        <div>Note</div>
                        <div>Actions</div>
                      </div>
                    }
                    itemTemplate={itemTemplate(item)}
                    dragdrop
                  ></OrderList>
                </div>
              </AccordionTab>
            );
          })}
        </Accordion>
      )}
      {/* Group Modal */}
      <Dialog
        header={`${mode === "create" ? "Create" : "Edit"} Menu Group`}
        visible={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        footer={() => (
          <div className="flex gap-2 justify-content-end">
            <Button
              label="Cancel"
              className="p-button-text"
              onClick={() => {
                setShowModal(false);
              }}
            />
            <Button
              label="Save"
              type="submit"
              className="p-button-success"
              onClick={
                mode === "create"
                  ? handleSubmit(onCreate)
                  : handleSubmit(onSaveEdit)
              }
            />
          </div>
        )}
        className="p-fluid"
      >
        <form key={1}>
          <Controller
            name="title"
            control={control}
            render={({ field }) => (
              <div className="field">
                <label>Title</label>
                <InputText className="w-full" {...field} />
              </div>
            )}
          />

          <Controller
            name="multiple"
            control={control}
            render={({ field }) => (
              <SelectButton
                {...field}
                options={["Single Choice", "Multiple Choice"]}
                allowEmpty={false}
                className={styles.isMultipleSelectButton}
              />
            )}
          />

          {multiple === "Multiple Choice" && (
            <Controller
              name="max_multiple"
              control={control}
              rules={{
                validate: (e) => {
                  if (e.value === null) return "This field is required";
                  if (e.value < 2) return "Must be 2 or more";
                },
              }}
              defaultValue={{ value: 2 }}
              render={({ field, fieldState }) => {
                return (
                  <div className="field">
                    <label>Max menu options</label>
                    <InputNumber
                      {...field}
                      className="w-full"
                      value={field.value.value}
                      onChange={(e) => {
                        field.onChange({ value: e.value });
                      }}
                    />
                    {fieldState.error && (
                      <small className={`p-error `}>
                        {fieldState.error.message}
                      </small>
                    )}
                  </div>
                );
              }}
            />
          )}
        </form>
      </Dialog>
      {/* Item Modal */}
      <Dialog
        header={`${mode === "create" ? "Create" : "Edit"} Menu Item Within ${
          currentGroup.group_name
        }`}
        visible={showItemModal}
        onHide={() => {
          setShowItemModal(false);
        }}
        footer={() => (
          <div className="flex gap-2 justify-content-end">
            <Button
              label="Cancel"
              className="p-button-text"
              onClick={() => {
                setShowItemModal(false);
              }}
            />
            <Button
              label="Save"
              type="submit"
              className="p-button-success"
              onClick={
                mode === "create"
                  ? handleSubmit2(onItemCreate)
                  : handleSubmit2(onItemSaveEdit)
              }
            />
          </div>
        )}
        className="p-fluid"
      >
        <form key={2}>
          <Controller
            name="item_title"
            control={control2}
            render={({ field }) => (
              <div className="field">
                <label>Title</label>
                <InputText className="w-full" {...field} />
              </div>
            )}
          />

          <Controller
            name="item_active"
            control={control2}
            render={({ field }) => (
              <SelectButton
                {...field}
                options={["Active", "Inactive"]}
                allowEmpty={false}
              />
            )}
          />

          <Controller
            name="item_cost"
            control={control2}
            render={({ field }) => {
              return (
                <div className="field">
                  <label>Cost</label>
                  <InputNumber
                    className="w-full"
                    minFractionDigits={2}
                    maxFractionDigits={2}
                    prefix="$"
                    {...field}
                    value={+field.value || null}
                    onChange={(e) => {
                      field.onChange(e.value);
                    }}
                    onChangeCapture={(e) => {
                      console.log(e.target.value);
                      field.onChange(e.target.value);
                    }}
                  />
                </div>
              );
            }}
          />

          <Controller
            name="item_note"
            control={control2}
            render={({ field }) => (
              <div className="field">
                <label>Note</label>
                <InputTextarea className="w-full" {...field} />
              </div>
            )}
          />
        </form>
      </Dialog>

      {/* Image modal */}
      <Dialog
        header={`${menuItem?.item.name} Image`}
        visible={showImageModal}
        onHide={() => {
          setShowImageModal(false);
        }}
        footer={() => (
          <div className="flex gap-2 justify-content-end">
            <Button
              label="Cancel"
              className="p-button-text"
              onClick={() => {
                setShowImageModal(false);
              }}
            />
            <FileUpload
              mode="basic"
              onSelect={onImageSelect}
              customUpload
              uploadHandler={onImageUpload}
              onUpload={() => {}}
              accept="image/*"
              selectedFileLabel="Upload"
            />
          </div>
        )}
        className="p-fluid"
      >
        <div>
          <Dropdown
            disabled
            placeholder={`Select ${menuItem?.group.group.group_name}`}
            options={[menuItem?.item.name]}
            style={{ width: "300px" }}
            itemTemplate={(item) => {
              return (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <div
                    style={{
                      height: "50px",
                      width: "75px",
                      backgroundColor: "gray",
                    }}
                  ></div>
                  {item}
                </div>
              );
            }}
            optionLabel="name"
            optionValue="id"
            panelClassName={styles.dropDownPanel}
          />
          <div
            class="p-dropdown-panel p-component p-ripple-disabled p-connected-overlay-enter-done"
            data-pc-section="panel"
            style={{ minWidth: "300px", position: "static" }}
          >
            <span
              role="presentation"
              class="p-hidden-accessible p-hidden-focusable"
              tabindex="0"
              data-p-hidden-accessible="true"
              data-p-hidden-focusable="true"
              data-pc-section="hiddenfirstfocusableel"
            ></span>
            <div
              class="p-dropdown-items-wrapper"
              data-pc-section="wrapper"
              style={{ maxHeight: "200px" }}
            >
              <ul
                class="p-dropdown-items"
                role="listbox"
                aria-label="Option List"
                data-pc-section="list"
              >
                <li
                  id="dropdownItem_0"
                  role="option"
                  class="p-dropdown-item p-focus"
                  tabindex="0"
                  aria-setsize="1"
                  aria-posinset="1"
                  aria-label="Diced Onion"
                  aria-selected="false"
                  data-p-highlight="false"
                  data-p-focused="true"
                  data-p-disabled="false"
                  data-pc-section="item"
                >
                  <span
                    class="p-dropdown-item-label"
                    data-pc-section="itemlabel"
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          backgroundImage: `url(${currentImage})`,
                          backgroundSize: "cover",
                          height: "50px",
                          width: "75px",
                          backgroundColor: "gray",
                        }}
                      ></div>
                      {menuItem?.item.name}
                    </div>
                  </span>
                </li>
              </ul>
            </div>
            <span
              role="presentation"
              class="p-hidden-accessible p-hidden-focusable"
              tabindex="0"
              data-p-hidden-accessible="true"
              data-p-hidden-focusable="true"
              data-pc-section="hiddenlastfocusableel"
            ></span>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default StationMenuItem;
